import { render, staticRenderFns } from "./CreateMenu.vue?vue&type=template&id=6409039e&scoped=true"
import script from "./CreateMenu.vue?vue&type=script&lang=js"
export * from "./CreateMenu.vue?vue&type=script&lang=js"
import style0 from "./CreateMenu.vue?vue&type=style&index=0&id=6409039e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409039e",
  null
  
)

export default component.exports